import { CreateTenantUserDto, Role } from "@/types/user";
import { withNormalizedPosition } from "./userPosition";
import type { UserFormData } from "./userSchemas";

const trimOptionalField = (
  target: CreateTenantUserDto,
  key: keyof CreateTenantUserDto,
) => {
  const value = target[key];
  if (typeof value !== "string" || value.trim()) {
    return;
  }
  delete (target as Partial<CreateTenantUserDto>)[key];
};

/** Body of POST /tenant-admin/users built from the Add New User form (the hook sends it as is). */
export const buildCreateTenantUserPayload = (
  userData: UserFormData,
  photoId?: string,
): CreateTenantUserDto => {
  const { role, customRoleId, ...baseUserData } = userData;
  delete baseUserData.roleMode;
  const email = userData.email?.trim() ?? "";
  const trimmedCustomRoleId = customRoleId?.trim();
  const useCustomRolePath = Boolean(trimmedCustomRoleId);
  const sanitizedRole =
    role === Role.TENANT_ADMIN
      ? undefined
      : (role as Exclude<Role, Role.TENANT_ADMIN> | undefined);
  const createUserData: CreateTenantUserDto = {
    ...baseUserData,
    username: email,
    photoId,
    role: useCustomRolePath ? undefined : sanitizedRole,
    customRoleId: useCustomRolePath ? trimmedCustomRoleId : undefined,
  };

  trimOptionalField(createUserData, "password");
  trimOptionalField(createUserData, "pin");
  trimOptionalField(createUserData, "email");
  trimOptionalField(createUserData, "hotelId");
  trimOptionalField(createUserData, "firstName");
  trimOptionalField(createUserData, "lastName");
  trimOptionalField(createUserData, "phone");
  if (!createUserData.role) {
    delete createUserData.role;
  }
  if (!createUserData.customRoleId) {
    delete createUserData.customRoleId;
  }

  // An empty position is not sent; a typed one is sent trimmed (DV-39).
  return withNormalizedPosition(createUserData);
};
